<template>
  <Layout>
    <!-- All Notification Heading -->
    <!-- <div class="nftmax-inner__heading">
      <h2 class="nftmax-inner__page-title">Settings</h2>
    </div> -->
    <!-- End All Notification Heading -->

    <div class="nftmax-personals">
      <h2 class="nftmax-personals__title">Settings</h2>
      <div class="row">
        <div class="col-lg-3 col-md-2 col-12 nftmax-personals__list">
          <div class="nftmax-psidebar">
            <!-- Features Tab List -->
            <div
              id="list-tab"
              class="list-group nftmax-psidebar__list"
              role="tablist"
            >
              <a
                class="list-group-item"
                :class="[tabActive === 'personal' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('personal')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="15"
                    height="20"
                    viewBox="0 0 15 20"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8692 11.6667H4.13085C3.03569 11.668 1.98576 12.1036 1.21136 12.878C0.436961 13.6524 0.00132319 14.7023 0 15.7975V20H15.0001V15.7975C14.9987 14.7023 14.5631 13.6524 13.7887 12.878C13.0143 12.1036 11.9644 11.668 10.8692 11.6667Z"
                    ></path>
                    <path
                      d="M7.49953 10C10.261 10 12.4995 7.76145 12.4995 5.00002C12.4995 2.23858 10.261 0 7.49953 0C4.7381 0 2.49951 2.23858 2.49951 5.00002C2.49951 7.76145 4.7381 10 7.49953 10Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title">Personal Info</span></a
              >
              <a
                v-if="!$store.state.userInfo.isThirdPartyLogin"
                class="list-group-item"
                :class="[tabActive === 'password' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('password')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    class="inline fill-current"
                    width="18"
                    height="21"
                    viewBox="0 0 18 21"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4467 7.1581V5.94904C14.4467 2.66455 11.7822 0 8.49771 0C5.21323 0 2.54867 2.66455 2.54867 5.94904V7.1581C1.00076 7.83194 -0.000366211 9.36059 -0.000366211 11.0471V16.149C0.0034843 18.494 1.90178 20.3961 4.25059 20.4H12.7525C15.0975 20.3961 16.9996 18.4978 17.0035 16.149V11.051C16.9919 9.36059 15.9908 7.83579 14.4467 7.1581ZM9.34482 14.451C9.34482 14.9207 8.96362 15.3019 8.49386 15.3019C8.0241 15.3019 7.6429 14.9207 7.6429 14.451V12.749C7.6429 12.2793 8.0241 11.8981 8.49386 11.8981C8.96362 11.8981 9.34482 12.2793 9.34482 12.749V14.451ZM12.7448 6.8H4.24289V5.94904C4.24289 3.60023 6.14505 1.69807 8.49386 1.69807C10.8427 1.69807 12.7448 3.60023 12.7448 5.94904V6.8Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title">Change Password </span></a
              >
              <!-- <a
                class="list-group-item"
                :class="[tabActive === 'payment' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('payment')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="19"
                    height="14"
                    viewBox="0 0 19 14"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5258 0H3.82277C1.71401 0.00346265 0.00346265 1.71055 0 3.82277H18.3451C18.3451 1.71401 16.6346 0.00346265 14.5258 0Z"
                    ></path>
                    <path
                      d="M0 9.93807C0.00346265 12.0468 1.71055 13.7574 3.82277 13.7608H14.5258C16.6346 13.7574 18.3451 12.0503 18.3486 9.93807V5.35352H0V9.93807ZM5.3498 9.55718C5.3498 10.1908 4.83733 10.7033 4.20366 10.7033C3.57 10.7033 3.05752 10.1908 3.05752 9.55718C3.05752 8.92351 3.57 8.41104 4.20366 8.41104C4.83733 8.41104 5.3498 8.92351 5.3498 9.55718Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title">Payment Method</span></a
              >
              <a
                class="list-group-item"
                :class="[tabActive === 'notification' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('notification')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.0413044 14.8498C-0.0591125 14.32 0.0032142 13.8871 0.456822 13.527C0.848102 13.2154 1.16667 12.8172 1.53717 12.4744C1.70684 12.3151 1.76224 12.1454 1.76224 11.9169C1.75532 10.3414 1.73108 8.76241 1.77263 7.1869C1.83496 4.85654 3.38276 2.81704 5.59886 2.06218C6.12519 1.88212 6.12519 1.88212 6.13211 1.32463C6.1425 0.400103 7.00124 -0.216249 7.87383 0.0711515C8.37245 0.233896 8.7291 0.694429 8.76027 1.22075C8.76719 1.33156 8.77758 1.44582 8.76027 1.55663C8.72564 1.8094 8.81567 1.92021 9.0719 1.99985C11.5165 2.73047 13.1267 4.90848 13.1267 7.46045C13.1267 7.81711 13.1267 8.17376 13.1267 8.50964C9.68826 9.24718 7.96386 11.3836 7.7561 14.8532C5.21797 14.8498 2.64176 14.8498 0.0413044 14.8498Z"
                    ></path>
                    <path
                      d="M16.9909 17.6617C16.655 17.5301 16.3642 17.4124 16.0733 17.3016C15.7132 17.1596 15.1072 17.5163 15.0588 17.9006C14.9272 18.9359 14.9272 18.9359 13.9022 18.9359C13.6114 18.9359 13.317 18.9602 13.0296 18.9221C12.9154 18.9082 12.7873 18.7732 12.7249 18.6589C12.6626 18.5516 12.6488 18.3958 12.6591 18.2677C12.7145 17.7136 12.3787 17.447 11.932 17.267C11.8523 17.2358 11.7381 17.2358 11.655 17.2635C11.4022 17.3535 11.1564 17.4609 10.9105 17.5647C10.682 17.6617 10.5158 17.6305 10.3876 17.3847C10.1591 16.9518 9.90633 16.5259 9.65356 16.107C9.5289 15.9027 9.55314 15.7538 9.74705 15.6222C9.85786 15.546 9.95134 15.4456 10.0691 15.3798C10.4638 15.1651 10.6231 14.8604 10.5712 14.4033C10.5469 14.1956 10.5123 14.0536 10.3357 13.9359C10.121 13.7939 9.93057 13.6208 9.72281 13.4684C9.55314 13.3472 9.53582 13.2122 9.6397 13.0356C9.90633 12.582 10.1695 12.1284 10.4292 11.6713C10.5296 11.4912 10.6681 11.4497 10.8516 11.5259C10.9763 11.5743 11.1044 11.6159 11.2221 11.6782C11.5996 11.8791 11.9493 11.9379 12.3267 11.6401C12.4756 11.5224 12.5968 11.4462 12.6107 11.2419C12.628 11.0099 12.6938 10.7779 12.7076 10.5459C12.7215 10.2793 12.8427 10.1685 13.1058 10.172C13.5975 10.1789 14.0892 10.1789 14.5809 10.172C14.8129 10.1685 14.9376 10.2551 14.9445 10.5009C14.948 10.6325 14.993 10.7641 14.9999 10.8991C15.0172 11.3008 15.1419 11.602 15.5643 11.7717C15.7825 11.8583 15.9452 11.8998 16.153 11.7994C16.3746 11.6955 16.5996 11.5847 16.8386 11.5328C16.9528 11.5086 17.1571 11.5778 17.2195 11.6713C17.5103 12.1214 17.7804 12.5854 18.0228 13.0633C18.0713 13.1602 18.0089 13.3472 17.9397 13.458C17.8739 13.5654 17.7458 13.6519 17.628 13.7073C17.1121 13.9463 17.0533 14.386 17.1052 14.8708C17.1156 14.9539 17.1848 15.0509 17.2541 15.1097C17.4688 15.2898 17.6904 15.4629 17.9155 15.6222C18.1094 15.7572 18.1405 15.9027 18.0193 16.1035C17.7562 16.5433 17.5069 16.9934 17.2402 17.4332C17.1779 17.5301 17.074 17.589 16.9909 17.6617ZM13.8434 15.8611C14.5601 15.8611 15.1419 15.2794 15.1419 14.5626C15.1419 13.8458 14.5636 13.271 13.8399 13.2676C13.1231 13.2641 12.5449 13.8458 12.5483 14.5661C12.5483 15.2932 13.1162 15.8611 13.8434 15.8611Z"
                    ></path>
                    <path
                      d="M5.69238 15.7393C6.45763 15.7393 7.17094 15.7393 7.88424 15.7393C8.04699 16.2275 8.20973 16.7088 8.38633 17.2317C7.8323 17.5572 7.24711 17.6056 6.65846 17.3113C6.03865 16.9997 5.72701 16.4768 5.69238 15.7393Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title"
                  >Notification Setting</span
                ></a
              >
              <a
                class="list-group-item"
                :class="[tabActive === 'activity' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('activity')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="14"
                    height="20"
                    viewBox="0 0 14 20"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.864 15.982C11.4632 12.6503 9.25877 11.1115 7.04363 11.0543C5.70166 11.0221 4.5422 11.5123 3.57598 12.4607C2.60976 13.4054 2.19465 14.5935 1.99067 16.0285C1.37873 15.7458 0.809733 15.506 0.272945 15.2126C0.147695 15.1446 0.0582333 14.8941 0.0582333 14.7259C0.0439189 13.5629 -0.0849134 12.3819 0.0940158 11.2475C0.365988 9.54055 1.99067 8.23794 3.71555 8.05544C4.60661 7.96239 5.46547 7.95166 6.35296 8.16995C6.88617 8.30236 7.51243 8.19142 8.06711 8.05902C10.2357 7.52938 13.1559 8.64948 13.7571 10.997C14.0577 12.1672 14.0577 13.3661 13.8751 14.5613C13.8107 14.9979 13.6068 15.32 13.1737 15.481C12.7336 15.6385 12.3042 15.8102 11.864 15.982Z"
                    ></path>
                    <path
                      d="M10.6071 3.72194C10.5928 5.77962 8.96814 7.38999 6.93193 7.36494C4.8814 7.33989 3.24241 5.7009 3.26388 3.69331C3.28535 1.59984 4.90287 -0.0212607 6.94982 0.000210833C9.01824 0.0181038 10.6215 1.64994 10.6071 3.72194Z"
                    ></path>
                    <path
                      d="M10.9477 16.0178C10.9119 18.2795 9.07609 19.9972 6.74286 19.9507C4.58139 19.9077 2.77779 18.0719 2.81 15.9498C2.84578 13.7454 4.69591 11.9776 6.93968 12.0062C9.17272 12.0384 10.9799 13.8492 10.9477 16.0178ZM6.84306 18.4834C7.27606 18.462 7.76991 18.4262 8.26375 18.419C8.62877 18.4154 8.75044 18.2222 8.75044 17.8966C8.75044 17.1808 8.75402 16.4687 8.74687 15.753C8.74687 15.6599 8.7075 15.5025 8.6574 15.4882C8.32817 15.4059 8.40332 15.1482 8.38185 14.9263C8.36396 14.7367 8.34249 14.547 8.3067 14.3645C8.1564 13.6309 7.64108 13.2122 6.91821 13.2229C6.22396 13.2337 5.64781 13.7418 5.52972 14.4432C5.46888 14.8154 5.65139 15.2735 5.17186 15.5096C5.15039 15.5204 5.15039 15.5919 5.15039 15.6349C5.15039 16.4508 5.13607 17.2667 5.16112 18.0826C5.1647 18.19 5.35079 18.3689 5.46888 18.3868C5.90547 18.4477 6.34205 18.4548 6.84306 18.4834Z"
                    ></path>
                    <path
                      d="M7.78818 15.3706C7.81323 14.8159 7.93491 14.2684 7.41601 13.9069C7.09036 13.6815 6.70745 13.6851 6.40327 13.9499C5.95953 14.3328 6.03826 14.8481 6.08836 15.3706C6.66451 15.3706 7.19414 15.3706 7.78818 15.3706ZM6.76113 17.643C6.8828 17.643 7.00448 17.643 7.11899 17.643C7.15836 17.3209 7.22635 17.0239 7.21561 16.7304C7.21204 16.6088 7.02953 16.4978 6.92933 16.3797C6.83986 16.4835 6.6824 16.5837 6.67883 16.6911C6.67167 16.9988 6.72892 17.3137 6.76113 17.643Z"
                    ></path>
                    <path
                      d="M7.78818 15.3706C7.19414 15.3706 6.66451 15.3706 6.08836 15.3706C6.03826 14.8445 5.95953 14.3328 6.40327 13.9499C6.71103 13.6851 7.09394 13.6815 7.41601 13.9069C7.93491 14.2684 7.81323 14.8159 7.78818 15.3706Z"
                    ></path>
                    <path
                      d="M6.76163 17.6421C6.72942 17.3129 6.67217 17.0016 6.67932 16.6902C6.6829 16.5865 6.84036 16.4827 6.92982 16.3789C7.03002 16.4934 7.21253 16.6079 7.21611 16.7296C7.22685 17.0231 7.15885 17.3201 7.11949 17.6421C7.00497 17.6421 6.88688 17.6421 6.76163 17.6421Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title">Login Activity</span></a
              >
              <a
                class="list-group-item"
                :class="[tabActive === 'faq' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('faq')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 0C3.80338 0 0 3.80622 0 8.5C0 13.1938 3.80623 17 8.5 17C13.1938 17 17 13.1938 17 8.5C16.9972 3.80907 13.1938 0.00568942 8.5 0ZM8.5 14.1695C8.10743 14.1695 7.79167 13.8537 7.79167 13.4612C7.79167 13.0686 8.10743 12.7528 8.5 12.7528C8.89257 12.7528 9.20833 13.0686 9.20833 13.4612C9.20833 13.8509 8.89257 14.1695 8.5 14.1695ZM9.86831 8.86128C9.4416 9.12868 9.19126 9.6009 9.20833 10.1016V10.6278C9.20833 11.0204 8.89257 11.3362 8.5 11.3362C8.10743 11.3362 7.79167 11.0204 7.79167 10.6278V10.1016C7.77176 9.08317 8.30371 8.13303 9.18273 7.62098C9.72038 7.32513 10.0049 6.71637 9.89107 6.11613C9.77728 5.54434 9.33066 5.09772 8.75887 4.98678C7.9908 4.84454 7.25118 5.35375 7.10894 6.12182C7.09472 6.20716 7.08618 6.2925 7.08618 6.37784C7.08618 6.77041 6.77042 7.08618 6.37785 7.08618C5.98528 7.08618 5.66952 6.77041 5.66952 6.37784C5.66952 4.81325 6.93825 3.54451 8.50569 3.54451C10.0703 3.54451 11.339 4.81325 11.339 6.38069C11.3333 7.41048 10.7729 8.36061 9.86831 8.86128Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title">FAQ </span></a
              >
              <a
                class="list-group-item"
                :class="[tabActive === 'condition' ? 'active' : '']"
                data-bs-toggle="list"
                role="tab"
                @click="tabHandler('condition')"
                ><span class="nftmax-psidebar__icon"
                  ><svg
                    width="17"
                    height="21"
                    viewBox="0 0 17 21"
                    class="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.10101 0C9.10101 1.3622 9.10101 2.64618 9.10101 3.93017C9.10101 4.65363 9.29915 4.84916 10.0256 4.84916C11.3267 4.84916 12.6278 4.84916 13.9685 4.84916C13.9685 7.41061 13.9685 9.91992 13.9685 12.4879C12.4231 12.3706 11.0427 12.7356 9.90016 13.798C8.77739 14.8473 8.30847 16.1639 8.34149 17.7216C8.11033 17.7346 7.9122 17.7542 7.71406 17.7542C5.43551 17.7542 3.16356 17.7542 0.885004 17.7477C0.20474 17.7542 0 17.5456 0 16.8547C0 11.5885 0 6.32216 0 1.05587C0 0.156425 0.158508 0 1.07653 0C3.55322 0 6.03652 0 8.51981 0C8.68493 0 8.85004 0 9.10101 0ZM6.99417 8.1406C8.09052 8.1406 9.19347 8.1406 10.2898 8.1406C10.8512 8.1406 11.1946 7.89944 11.155 7.50838C11.1088 7.01955 10.7653 6.8892 10.3228 6.89572C9.35198 6.90223 8.38772 6.8892 7.41686 6.8892C6.16861 6.8892 4.92036 6.8892 3.67211 6.89572C3.0843 6.90223 2.79371 7.18249 2.88617 7.63222C2.97203 8.03631 3.27584 8.13408 3.63908 8.13408C4.76185 8.1406 5.87801 8.1406 6.99417 8.1406ZM7.0272 10.1676C5.91103 10.1676 4.79487 10.1741 3.67871 10.1676C3.2296 10.1676 2.88617 10.311 2.88617 10.8063C2.88617 11.2886 3.2296 11.3994 3.65229 11.3994C5.88462 11.3929 8.11694 11.3929 10.3559 11.3994C10.8116 11.3994 11.1682 11.2495 11.155 10.7737C11.1418 10.2914 10.772 10.1676 10.3228 10.1741C9.2265 10.1806 8.13015 10.1676 7.0272 10.1676ZM5.13831 14.6974C5.66006 14.6974 6.18182 14.7039 6.70357 14.6909C7.11305 14.6844 7.39705 14.5019 7.40365 14.0717C7.41026 13.635 7.12626 13.4655 6.71018 13.4655C5.66667 13.4721 4.62315 13.4655 3.58625 13.4655C3.17016 13.4655 2.88617 13.6285 2.88617 14.0652C2.89277 14.4888 3.17016 14.6844 3.57964 14.6844C4.09479 14.7039 4.61655 14.6974 5.13831 14.6974ZM5.01282 4.84264C5.49495 4.84264 5.98368 4.84916 6.46581 4.84264C6.84887 4.83613 7.13287 4.65363 7.14608 4.25605C7.15268 3.83892 6.8819 3.61732 6.46581 3.61732C5.49495 3.6108 4.52409 3.6108 3.55322 3.61732C3.16356 3.61732 2.89938 3.80633 2.87957 4.20391C2.85975 4.6406 3.15035 4.82961 3.55322 4.84264C4.04196 4.85568 4.52409 4.84264 5.01282 4.84264Z"
                    ></path>
                    <path
                      d="M9.60305 17.3306C9.60965 15.3166 11.274 13.6937 13.3148 13.7002C15.3424 13.7067 17.0133 15.3687 17.0001 17.3697C16.9869 19.3706 15.3093 21.0065 13.2752 21C11.2476 20.9935 9.59644 19.3445 9.60305 17.3306ZM12.8062 17.5065C12.6147 17.3306 12.4892 17.2263 12.3703 17.1155C12.0731 16.8222 11.7363 16.77 11.4391 17.0699C11.1287 17.3827 11.2344 17.7021 11.525 17.9889C11.7495 18.2105 11.9675 18.4386 12.1986 18.6537C12.6213 19.0578 12.9383 19.0643 13.3544 18.6602C13.863 18.1713 14.3517 17.6695 14.8602 17.1807C15.1772 16.8743 15.3622 16.555 14.9857 16.19C14.6291 15.838 14.279 15.9684 13.9686 16.2943C13.5856 16.6853 13.2091 17.0894 12.8062 17.5065Z"
                    ></path>
                    <path
                      d="M10.3955 3.56557C10.3955 2.43801 10.3955 1.32349 10.3955 0.228516C11.5183 1.34956 12.6344 2.46408 13.7374 3.56557C12.6873 3.56557 11.5579 3.56557 10.3955 3.56557Z"
                    ></path></svg></span
                ><span class="nftmax-psidebar__title"
                  >Terms and Conditions
                </span></a
              > -->
            </div>
          </div>
        </div>

        <div class="col-lg-9 col-md-10 col-12 nftmax-personals__content">
          <div class="nftmax-ptabs">
            <div class="nftmax-ptabs__inner">
              <div id="nav-tabContent" class="tab-content">
                <div
                  id="id1"
                  :class="[tabActive === 'personal' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Personal />
                </div>
                <div
                  id="id2"
                  :class="[tabActive === 'payment' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Payment />
                </div>
                <div
                  id="id3"
                  :class="[tabActive === 'notification' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Notification />
                </div>
                <div
                  id="id4"
                  :class="[tabActive === 'activity' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Activity />
                </div>
                <div
                  id="id5"
                  :class="[tabActive === 'password' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Password />
                </div>
                <div
                  id="id6"
                  :class="[tabActive === 'faq' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <FAQ />
                </div>
                <div
                  id="id7"
                  :class="[tabActive === 'condition' ? 'show active' : '']"
                  class="tab-pane fade"
                  role="tabpanel"
                >
                  <Condition />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Partials/Layout";
import Personal from "@/components/Settings/Tabs/Personal";
import Payment from "@/components/Settings/Tabs/Payment";
import Notification from "@/components/Settings/Tabs/Notification";
import Activity from "@/components/Settings/Tabs/Activity";
import Password from "@/components/Settings/Tabs/Password";
import FAQ from "@/components/Settings/Tabs/FAQ";
import Condition from "@/components/Settings/Tabs/Condition";
export default {
  components: {
    Condition,
    FAQ,
    Password,
    Activity,
    Notification,
    Payment,
    Personal,
    Layout,
  },
  data() {
    return {
      tabActive: "personal",
    };
  },
  methods: {
    tabHandler(value) {
      this.tabActive = value;
    },
  },
};
</script>

<style scoped></style>
